import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import KycMessaging from '../../components/KycMessaging';

import {
  displayModal
} from '@xanadu/ui-shared/modules/modal/actions';

import {
  depositRequest
} from '@xanadu/ui-shared/modules/user/actions';

const mapDispatchToProps = {
  displayModal,
  depositRequest
};

function mapStateToProps(state) {
  return {
    widthSize: state.getIn(['application', 'widthSize']),
    proofOfAddressStatus: state.getIn(['user', 'proofOfAddressStatus']),
    proofOfIdentityStatus: state.getIn(['user', 'proofOfIdentityStatus']),
    eddStatus: state.getIn(['user', 'eddStatus']),
    extraData: state.getIn(['modal', 'extraData']),
    cashierStatus: state.getIn(['user', 'cashierStatus']),
    countryId: state.getIn(['user', 'countryId']),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(KycMessaging));
